export enum SearchFiltersPosition {
  AS_TITLE = 'AS_TITLE',
  IS_DESKTOP_NAVBAR = 'IS_DESKTOP_NAVBAR',
  MOBILE = 'MOBILE'
}
